import { render, staticRenderFns } from "./CampaignCommissionList.vue?vue&type=template&id=48e955e4&"
import script from "./CampaignCommissionList.vue?vue&type=script&lang=js&"
export * from "./CampaignCommissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports